const Search = ($, context) => {

  const $wrapper = $(context)
  const $openSearch = $("#top-nav .open-search", context)
  const $closeSearch = $("#full-search .close-search", context)
  const $search = $("#full-search", context)

  const $searchInput = $("#full-search #search-text", context)

  const openSearch = (e) => {
    e && e.preventDefault()
    $search.addClass('open')
    $wrapper.addClass('search-open')
    $("body").addClass('noscroll')

  }

  const closeSearch = (e) => {
    e && e.preventDefault()
    $search.removeClass('open')
    $wrapper.removeClass('search-open')
    $("body").removeClass('noscroll')
  }

  const validateForm = (e) => {
    $search.toggleClass('valid', !!e.target.value)
  }

  var self = {
    init: () => {
      $openSearch.on('click', openSearch)
      $closeSearch.on('click', closeSearch)
      $searchInput.on('input', validateForm)
    }
  }

  return self;
}

export default Search